import { mangaList } from '@/mocks/manga';
import { formatViews } from '@/mocks/manga';

const hotIds = ['m01', 'm04', 'm16', 'm06', 'm03', 'm11'];

export default function HotSection() {
  const hot = hotIds
    .map((id) => mangaList.find((m) => m.id === id))
    .filter((m): m is NonNullable<typeof m> => Boolean(m));

  return (
    <section id="hot" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
            <i className="ri-fire-fill text-primary-500" />
            热门连载
          </h2>
          <p className="mt-1 text-sm text-foreground-600">当下最受追捧、讨论度最高的连载作品</p>
        </div>
        <span className="text-xs text-foreground-500">已收录 1800+ 部</span>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {hot.map((m, i) => (
          <a
            key={m.id}
            href="#reading"
            className="group relative flex gap-4 overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 p-4 transition hover:-translate-y-1 hover:ring-accent-400/40"
          >
            <span className="absolute right-3 top-2 font-heading text-5xl leading-none text-background-300/60 transition group-hover:text-accent-400/70">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div className="relative h-28 w-20 shrink-0 overflow-hidden rounded-md sm:h-32 sm:w-[5.75rem]">
              <img
                src={m.cover}
                alt={`${m.title} 免费漫画高清封面`}
                title={`${m.title} ${m.subtitle}`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col justify-center">
              <h3 className="truncate text-base font-bold text-foreground-950">{m.title}</h3>
              <p className="mt-0.5 truncate text-xs text-foreground-600">{m.subtitle}</p>
              <p className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-primary-500/15 px-2 py-0.5 text-[11px] text-primary-400">{m.category}</span>
                <span>{m.latestChapter}</span>
              </p>
              <p className="mt-2 flex items-center gap-1 text-[11px] text-foreground-500">
                <i className="ri-eye-line" />
                {formatViews(m.views)} 人气 · {m.rating} 分
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}